<script setup lang="ts">
import { WordList } from "~/classes/models/thesaurus/word-list.model";

const documentId = inject("documentId") as any;
const submittedDocumentStore = useSubmittedDocumentStore(documentId);
const { submittedDocument } = storeToRefs(submittedDocumentStore);

const thesaurusStore = useDocumentThesaurusStore(documentId);
const { isInitialized, pages, underlinedWords, wordLists } =
  storeToRefs(thesaurusStore);

const onTapWord = (word: string) => {
  const page = {
    type: ThesaurusPageType.word,
    key: word,
    data: undefined,
    isLoading: ref(true),
  } as ThesaurusPage;
  thesaurusStore.addPage(page);
};

const onTapBannedWord = (wordList: WordList, key: string) => {
  const page = {
    label: key,
    type: ThesaurusPageType.bannedWords,
    key: key,
    data: wordList,
    isLoading: ref(false),
  } as ThesaurusPage;
  thesaurusStore.addPage(page);
};

const wordListWords = computed(() => {
  return (wordList: WordList) => {
    // Return 10 random words from the word list
    const words = [...wordList.words];
    return words.sort(() => Math.random() - 0.5).slice(0, 10);
  };
});

const onTapSeeAll = (wordList: WordList) => {
  const page = {
    type: ThesaurusPageType.wordList,
    key: wordList.id,
    data: wordList,
    label: wordList.label,
  } as ThesaurusPage;
  thesaurusStore.addPage(page);
};

const showYourDressUps = computed(() => {
  return submittedDocument.value?.checklistId != undefined;
});

const blacklistedWords = computed(() => {
  return [
    "who",

    "whom",

    "whose",

    "which",

    "who's",

    "when",

    "while",

    "where",

    "as",

    "since",

    "if",

    "although",

    "because",
  ];
});

const validUnderlinedWords = computed(() => {
  return underlinedWords.value
    .filter((word) => {
      return !blacklistedWords.value.includes(word.text.toLowerCase().trim());
    })
    .filter((word) => {
      // If the word contians multiple words split by spaces, return false
      if (word.text.includes(" ")) return false;
      return true;
    });
});
</script>

<template>
  <div v-auto-animate>
    <div v-if="isInitialized != true">
      <DocumentEditorReviewPanelThesaurusWordList
        v-for="i in 3"
        :key="i"
        class="mb-6"
      />
    </div>
    <div v-if="isInitialized == true">
      <DocumentEditorReviewPanelThesaurusWordList
        v-for="wordList in wordLists"
        :key="wordList.id"
        class="mb-6"
      >
        <template #label>{{ wordList.label }} </template>
        <template #words>
          <DocumentEditorReviewPanelThesaurusTappableWord
            v-for="(words, key) in wordList.bannedWords"
            :key="key"
            :word="key"
            class="text-danger-default"
            @click="onTapBannedWord(wordList, key as string)"
          >
            {{ key }}
          </DocumentEditorReviewPanelThesaurusTappableWord>
          <DocumentEditorReviewPanelThesaurusTappableWord
            v-for="(word, key) in wordListWords(wordList)"
            :key="key"
            :word="word"
            :disabled="wordList.isReadOnly"
            @click="onTapWord(word)"
          >
            {{ word }}
          </DocumentEditorReviewPanelThesaurusTappableWord>
          <div
            class="flex flex-row items-center gap-1 cursor-pointer text-secondary-default hover:bg-light-default rounded px-[2px] py-[1px] transition-colors"
            @click="onTapSeeAll(wordList)"
          >
            <span class="text-body-2"> see all </span>
            <BaseIconArrowRight class="mt-[1px]" />
          </div>
        </template>
      </DocumentEditorReviewPanelThesaurusWordList>
    </div>
  </div>
</template>

<style scoped></style>
